<template>
  <div class="page rd">
    <Header />

    <section class="hero">
      <div class="hero-overlay">
        <div class="date">
          <div class="time">TIME {{ time }}</div>
          <div class="tag">{{ categoryName }}</div>
        </div>
        <div class="title">
          {{ title }}
        </div>
      </div>
    </section>

    <div class="section navigation">
      <div class="section-container">首页 > 新闻动态 > 新闻详情</div>
    </div>

    <section class="section news">
      <div class="section-container">
        <div class="news_detail">
          <div class="news_content" v-html="newsContent">
            <!-- <p>
              2月25日，晴空万里，迎着新春的滚滚东，河南省委书记刘宁一行前往河南某新材料科技公司调研指导工作。一到该公司调研的车还没有停稳，刘书记就向公司的李总亲切问好。
            </p>
            <p>
              据公司李总介绍，刘书记是第二次率团到公司考察并指导生产，李总回忆，刘书记第一次来公司是在2023年的夏天，那时候公司刚完成技术升级，这一次考察则是在光电材料的生产车间，极大提升了公司在行业内的技术竞争力。
            </p>
            <p>
              在2025年考察期间，刘书记在参观时指出，刘博士（公司核心技术顾问）带领公司进一步加大投入，不断钻研技术突破材料的技术瓶颈，同时他希望，企业要开阔另外的市场，提升公司经营的活力。刘博士对刘书记的讲话表示感谢，他提到，2024年公司要实现利润再创新高目标，这一次刘书记到公司考察又注入了极大动力。
            </p>
            <img src="../static/job/head_bg.png" alt="" />
            <p>
              在生产车间，李总向刘书记展示了公司的主打产品：公司研发的000纳米级材料解决了芯片行业的关键技术难题，打破了国外的技术垄断，同时“跨领域推广”的新模式，为公司的利润增长提供了新的支撑。
            </p>
            <p>
              刘宁书记认真听了每一项汇报，对公司取得的成绩表示充分肯定，他希望，企业要持续深化研究及成果应用，同时进一步加强成果转化，继续发力完善产业链布局，助力全省产业升级，助推行业的发展，构建最坚实的“专精特新”产业集群，为河南乃至全国的产业发展贡献更强的力量。
            </p>
            <img src="../static/job/head_bg.png" alt="" />
            <p>
              在生产车间，李总向刘书记展示了公司的主打产品：公司研发的000纳米级材料解决了芯片行业的关键技术难题，打破了国外的技术垄断，同时“跨领域推广”的新模式，为公司的利润增长提供了新的支撑。
            </p>
            <p>
              刘宁书记认真听了每一项汇报，对公司取得的成绩表示充分肯定，他希望，企业要持续深化研究及成果应用，同时进一步加强成果转化，继续发力完善产业链布局，助力全省产业升级，助推行业的发展，构建最坚实的“专精特新”产业集群，为河南乃至全国的产业发展贡献更强的力量。
            </p> -->
          </div>
          <!-- 侧边栏 -->
          <div class="sidebar">
            <div class="recommand">
              <h3>推荐新闻</h3>
              <div class="sidebar-item" v-for="(item,index) in recommendList" :key="index" @click="toRecommand(item)">
                <p>TIME:{{item.publishDate}}</p>
                <p class="title">
                  {{ item.title }}
                </p>
              </div>
            </div>

            <div class="operations">
              <p v-if="pre" @click="toPre">
                <img src="../static/news/icon_pre.png" alt="" />
                上篇文章
              </p>
              <p v-if="next" @click="toNext">
                <img src="../static/news/icon_next.png" alt="" />
                下篇文章
              </p>
              <p @click="toList">
                <img src="../static/news/icon_list.png" alt="" />
                返回列表
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="operations_mobile">
      <p v-if="pre" @click="toPre">
        <img src="../static/news/icon_pre.png" alt="" />
        上篇文章
      </p>
      <p v-if="next" @click="toNext">
        <img src="../static/news/icon_next.png" alt="" />
        下篇文章
      </p>
      <p @click="toList">
        <img src="../static/news/icon_list.png" alt="" />
        返回列表
      </p>
    </div>
    <!-- 联系我们 -->
    <contactModule />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import contactModule from "../components/contactModule.vue";
import { NewsAPI } from "../api/api";
import { imageBaseUrl } from "../api/config";
import dayjs from "dayjs";

export default {
  name: "News",
  components: {
    Header,
    Footer,
    contactModule,
  },
  data() {
    return {
      time: "",
      categoryName: "",
      title: "",
      // todo 内容区域待接入
      newsContent: "",

      recommendList: [],
      pre: null,
      next: null,
    };
  },
  // 实现当前页切换新闻
  watch: {
    // 监听路由参数变化
    "$route.params.id": {
      immediate: true,
      handler(newId, oldId) {
        if (!newId) {
          return;
        }
        if (newId !== oldId) {
          this.getPageData();
        }
      },
    },
  },

  methods: {
    getPageData() {
      NewsAPI.getContentDetail(this.$route.params.id).then((res) => {
        console.log("新闻详情", res);
        this.time = dayjs(res.createTime).format("YYYY.MM.DD");
        this.categoryName = res.categoryName
        this.title = res.title
        this.recommendList = res.recommendedNews || []
        this.pre = res.previousNews
        this.next = res.nextNews

        this.newsContent = res.content
      });
    },
    toPre() {
      this.$router.replace(`/news/${this.pre.id}`);
    },
    toNext() {
      this.$router.replace(`/news/${this.next.id}`);
    },
    toList() {
      this.$router.back();
    },
    toRecommand(item){
      this.$router.replace(`/news/${item.id}`);
    }
  },
};
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .operations_mobile {
    display: none;
  }
  .section {
    padding-bottom: 100px;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }
  }

  .hero {
    position: relative;
    height: 580px;
    background: url("../static/news/detail_head_bg.png") center/cover no-repeat;

    .hero-overlay {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      overflow: hidden;

      .date {
        margin-top: 249px;
        gap: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #909194;
      }

      .title {
        width: 872px;
        margin-top: 40px;
        font-weight: 600;
        font-size: 40px;
        color: #363636;
        line-height: 50px;
      }
    }
  }

  .navigation {
    padding: 0 40px !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 50px;
  }

  .news {
    .news_detail {
      display: flex;
      align-items: flex-start;
      gap: 70px;

      .news_content {
        flex: 1;

        /deep/p {
          font-size: 14px;
          color: #888888;
          margin-bottom: 53px;
        }

        /deep/img {
          width: 100%;
        }
      }

      .sidebar {
        width: 450px;

        .recommand {
          background: #f7f8fa;
          padding: 44px 44px 15px 44px;
        }

        h3 {
          font-size: 28px;
          color: #000000;
          font-weight: bold;
        }

        .sidebar-item {
          cursor: pointer;
          padding: 30px 0;
          border-bottom: 1px solid #e5e5e5;

          &:last-child {
            border-bottom: none;
          }

          p {
            margin-bottom: 14px;
            font-size: 14px;
            color: #909194;
          }

          .title {
            font-size: 18px;
            color: #363636;
            font-weight: bold;
          }

          .title:hover {
            color: #0248ff;
          }
        }
      }

      .operations {
        margin-top: 60px;

        p {
          cursor: pointer;
          padding: 22px;
          font-size: 16px;
          color: #363636;
          border-top: 1px solid #e5e5e5;
          border-bottom: 1px solid #e5e5e5;

          img {
            width: 18px;
            height: 18px;
            margin-right: 26px;
          }

          &:nth-child(2) {
            border: none;
          }
        }

        p:hover {
          color: #0248ff;
        }
      }
    }
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}
// mobile
@media (max-width: 750px) {
  .operations_mobile {
    display: flex;
    align-items: center;
    justify-content: space-around;

    p {
      cursor: pointer;
      padding: 11px;
      font-size: 12px;
      color: #363636;

      img {
        width: 9px;
        height: 9px;
        margin-right: 13px;
      }
    }
  }
  .section {
    padding-bottom: 50px;

    .section-container {
      padding: 0 24px;
    }
  }

  .hero {
    position: relative;
    height: 229px;
    background: url("../static/news/detail_head_bg.png");
    background-size: 100% 100%;

    .hero-overlay {
      padding: 55px 24px 0;

      .date {
        gap: 20px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #909194;
        margin-top: 30px;
      }

      .title {
        margin-top: 14px;
        font-weight: 600;
        font-size: 20px;
        color: #363636;
        line-height: 25px;
      }
    }
  }

  .navigation {
    padding: 0 !important;
    font-weight: 400;
    font-size: 12px;
    color: #c2c2c2;
    line-height: 64px;
    margin-bottom: 25px;
  }

  .news {
    padding-bottom: 0 !important;
    .news_detail {
      display: flex;
      align-items: flex-start;
      gap: 70px;

      .news_content {
        flex: 1;

        /deep/p {
          font-size: 12px;
          color: #888888;
          margin-bottom: 22px;
        }

        /deep/img {
          width: 100%;
        }
      }

      .sidebar {
        display: none;
        width: 450px;

        .recommand {
          background: #f7f8fa;
          padding: 44px 44px 15px 44px;
        }

        h3 {
          font-size: 28px;
          color: #000000;
          font-weight: bold;
        }

        .sidebar-item {
          cursor: pointer;
          padding: 30px 0;
          border-bottom: 1px solid #e5e5e5;

          &:last-child {
            border-bottom: none;
          }

          p {
            margin-bottom: 14px;
            font-size: 14px;
            color: #909194;
          }

          .title {
            font-size: 18px;
            color: #363636;
            font-weight: bold;
          }

          .title:hover {
            color: #0248ff;
          }
        }
      }

      .operations {
        margin-top: 60px;

        p {
          cursor: pointer;
          padding: 22px;
          font-size: 16px;
          color: #363636;
          border-top: 1px solid #e5e5e5;
          border-bottom: 1px solid #e5e5e5;

          img {
            width: 18px;
            height: 18px;
            margin-right: 26px;
          }

          &:nth-child(2) {
            border: none;
          }
        }

        p:hover {
          color: #0248ff;
        }
      }
    }
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}
</style>
